import React from "react";

import TempLogo from "../../Photos/Nav Mario.svg"
import { Page } from "../../App";

interface NavbarProps {setPage: React.Dispatch<React.SetStateAction<number>>;}
const offset = -100; // Adjust this offset to match the height of your navbar or the amount you want to scroll up

export class Navbar extends React.Component<NavbarProps> {
    toggleNavbar = () => {
        const navbar = document.getElementById("navbar");
        if (navbar) {
            if (navbar.className === "nav-bar") {
                navbar.className += " responsive";
            } else {
                navbar.className = "nav-bar";
            }
        }
    };

    handleScroll = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetId: string) => {
        event.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset + offset;
            window.scrollTo({
                top: elementPosition,
                behavior: "smooth"
            });
        }
    };

    render() {
        return (
                <nav className="nav-bar" id="navbar">
                    <a href="#" target="_self" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.WELCOME); }}>
                        <img className="nav-logo" src={TempLogo} alt="course logo" style={{height: "100%", aspectRatio: "1"}}/>
                    </a>

                    <button className="icon" onClick={this.toggleNavbar}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="6"  x2="21" y2="6"/>
                            <line x1="3" y1="12" x2="21" y2="12"/>
                            <line x1="3" y1="18" x2="21" y2="18"/>
                        </svg>
                    </button>

                    <a className="nav-link" href="#assignments" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.ASSIGNMENTS); }} target="_self">Assignments</a>
                    <a className="nav-link" href="#lectures" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.LECTURES); }} target="_self">Lectures</a>
                    <a className="nav-link" href="#sections" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.LABS); }} target="_self">Sections</a>
                    <a className="nav-link" href="#codealong" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.CODEALONG); }} target="_self">Code-along</a>
                    <a className="nav-link" href="#hours" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.HOURS); }} target="_self">Hours</a>
                    <a className="nav-link" href="#src" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.SRC); }} target="_self">SRC</a>
                    <a className="nav-link" href="#resources" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.RESOURCES); }} target="_self">Resources</a>
                    <a className="nav-link" href="#staff" onClick={(e) => { e.preventDefault(); this.props.setPage(Page.STAFF); }} target="_self">Staff</a>
                </nav>
        );
    }
}
